import React from 'react';
export function PromoBanner() {
  return <div className="bg-near-black text-cream py-1.5 px-4 text-center text-[10px] md:text-sm font-body font-bold tracking-widest uppercase z-50" data-id="element-287">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-1 md:gap-6" data-id="element-288">
        <span className="flex items-center gap-2 text-brand-gold whitespace-nowrap" data-id="element-289">
          ✨ OPEN 24/7 ✨
        </span>
        <span className="hidden md:inline text-cream/30" data-id="element-290">•</span>
        <div className="flex items-center gap-3 md:gap-6" data-id="element-291">
          <span className="flex items-center gap-1" data-id="element-292">
            ☎️:{' '}
            <a href="tel:2409217857" className="hover:text-brand-gold transition-colors underline underline-offset-4" data-id="element-293">
              2409217857
            </a>
          </span>
          <span className="md:hidden text-cream/30" data-id="element-294">•</span>
          <span className="flex items-center gap-1 truncate max-w-[150px] md:max-w-none" data-id="element-295">
            📍 LANHAM MD
          </span>
        </div>
      </div>
    </div>;
}